export const QUERY_KEY = 'cart-summary';
